<p>{{ 'Velg gruppemedlem som representerer aksjepost i generalforsamlingen'|translate }}</p>

@if (skjema().length > 0) {

  <div class="antall-tildelt" [class.antall-tildelt__ikke-alle]="antallAksjeeiereUtenRepresentantTildelt() > 0">
    <span>
      {{ '{andel} av {totalt} aksjeposter er representert av et gruppemedlem'|translate:{andel: antallAksjeeiereMedRepresentantTildelt(), totalt: skjema().length} }}
    </span>
  </div>

  <fieldset>
    <table class="aksjeeiere">
      <tr>
        <th>{{ 'Aksjepost'|translate }}</th>
        <th>{{ 'Eierandel'|translate }}</th>
        <th class="medlem">{{ 'Representeres av gruppemedlem'|translate }}</th>
      </tr>
      @for (rad of skjema().controls; track rad.value.aksjeeier!.id) {
        <tr class="aksjeeier">
          <td class="navn">{{ rad.value.aksjeeier!.navn }}</td>
          <td class="eierandel">
            ({{ rad.value.aksjeeier!.naavaerendeBeholdning?.eierandel | prosent }}
            <span class="aksjeklasse" [matTooltip]="rad.value.aksjeeier!.naavaerendeBeholdning?.aksjeklasse?.beskrivelse">{{ rad.value.aksjeeier!.naavaerendeBeholdning?.aksjeklasse?.navn }}</span>)
          </td>
          <td class="medlem">
            <mat-form-field class="mat-form-field-dense-3 medlemvelger" subscriptSizing="dynamic">
              <mat-select [formControl]="rad.controls.medlem" [compareWith]="erValgtMedlem" panelWidth="300px" panelClass="medlemvelger--alternativer" data-testid="medlemvelger-felt">
                <mat-option [value]="null" class="ingen-valgt" data-testid="ingen-valgt">
                  {{ "Ingen valgt"|translate }}
                </mat-option>
                <mat-option [value]="{}" (onSelectionChange)="visNyInvitasjonSkjema(rad,$event)" class="legg-til-nytt" data-testid="legg-til-nytt-medlem-valg">
                  {{ "Legg til nytt medlem"|translate }}
                </mat-option>
                @for (medlem of aktiveMedlemmer(); track medlem.id) {
                  <mat-option [value]="medlem">
                    {{ medlem.navn }}
                    <span class="medlemsrolle">{{ aktiveRolleMedParentesRundt(medlem) }}</span>
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </td>
        </tr>
        @if (rad.value.erNyInvitasjon) {
          <tr class="ny-invitasjon-skjema">
            <td colspan="3">
              <div class="ny-invitasjon-kontainer">
                <div class="ramme-tittel">{{ "Ny invitasjon til gruppen"|translate }}</div>
                <medlem-invitasjon-skjema [skjema]="rad.controls.nyInvitasjonForAksjeeier.controls.nyInvitasjonSkjema" fokuserEpostFelt="true"/>
                <div class="avbryt">
                  <a (click)="vedAvbrytNyMedlem(rad)">{{ "Avbryt"|translate }}</a>
                </div>
              </div>
            </td>
          </tr>
        }
      }
    </table>
  </fieldset>

  <div class="meldinger-til-bruker">
    @if (antallAksjeeiereUtenRepresentantTildelt() > 0) {
      <inline-melding type="advarsel">
        {{ '{antall} aksjeposter mangler representant.'|translate:{antall: antallAksjeeiereUtenRepresentantTildelt()} }}
      </inline-melding>
    }

    @if (inneholderInvitasjoner()) {
      <tips>
        {{ "Merk: nye medlemmer får lesetilgang i {tittel} i {organisasjonsnavn}, og blir invitert til gruppen når du lagrer møtet." | translate: {tittel: gruppe().tittel, organisasjonsnavn: gruppe().organisasjonsnavn} }}
      </tips>
    }
  </div>

} @else {
  <tips class="e2e-ingen-saker-tips">
    <!--@todo tilby lenke?-->
    <!--@todo sørge for at dette ikke vises mens vi laster data? - feks ved en forsinket vising -->
    <span>{{ 'Aksjeeierboken inneholder ingen aksjeeiere, rediger aksjeeierboken for å legge til aksjeeiere.'|translate }}</span>
  </tips>
}
